import { DeepPartial } from 'redux'

import { FeedbotThunk } from '../../../store/types'
import { botNlpActions } from '../../../store/botNlp'
import { IntentId, NlpIntent, NlpModelId } from '@feedyou-ai/feedbot-schema'
import { modalsActions } from '../../../store/modals/modalsSlice'

export function close(): FeedbotThunk {
  return dispatch => {
    dispatch(modalsActions.closeModal())
  }
}

export function save(
  modelId: NlpModelId,
  intentId: IntentId,
  intentProps: DeepPartial<NlpIntent>
): FeedbotThunk {
  return dispatch => {
    if (modelId && intentId) {
      dispatch(botNlpActions.updateModelIntent({ modelId, itemId: intentId, props: intentProps }))
    }

    dispatch(close())
  }
}
